<template>
  <div class="membership-card-bg-parts">
    <svg
      class="membership-card-bg-parts__image membership-card-bg-parts__image--pc"
      width="800"
      height="529"
      viewBox="0 0 800 529"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#membership-card-bg-gradient--pc)">
        <rect
          opacity="0.4"
          width="268.792"
          height="828.667"
          transform="matrix(0.866053 -0.499953 0.500047 0.865998 -123.421 -67.2583)"
          fill="black"
        />
        <rect
          width="290.124"
          height="975.84"
          transform="matrix(-0.866053 -0.499953 -0.500047 0.865998 872.212 -152.097)"
          :fill="membersColor.color"
          :opacity="membersColor.opacity"
        />
        <rect
          x="-1390"
          y="241"
          width="3580"
          height="184"
          fill="url(#membership-card-bg-gradient--pc)"
        />
        <rect x="-1390" y="425" width="3580" height="394" fill="#2B2B2B" />
      </g>
      <defs>
        <linearGradient
          id="membership-card-bg-gradient--pc"
          x1="400"
          y1="241"
          x2="400"
          y2="425"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2B2B2B" stop-opacity="0" />
          <stop offset="1" stop-color="#2B2B2B" />
        </linearGradient>
        <clipPath id="clip0_218_4158">
          <rect width="800" height="529" fill="white" />
        </clipPath>
      </defs>
    </svg>

    <svg
      class="membership-card-bg-parts__image membership-card-bg-parts__image--sp"
      width="375"
      height="658"
      viewBox="0 0 375 658"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#membership-card-bg-gradient--sp)">
        <rect width="375" height="658" fill="#393939" />
        <rect
          opacity="0.4"
          x="-57.8535"
          y="-31.5352"
          width="126"
          height="388.474"
          transform="rotate(-30 -57.8535 -31.5352)"
          fill="black"
        />
        <rect
          width="136"
          height="457.468"
          transform="matrix(-0.866025 -0.5 -0.5 0.866025 408.514 -67)"
          :fill="membersColor.color"
          :opacity="membersColor.opacity"
        />
        <rect
          x="-695"
          y="80"
          width="1765"
          height="184"
          fill="url(#membership-card-bg-gradient--sp)"
        />
        <rect x="-695" y="264" width="1765" height="394" fill="#2B2B2B" />
      </g>
      <defs>
        <linearGradient
          id="membership-card-bg-gradient--sp"
          x1="187.5"
          y1="80"
          x2="187.5"
          y2="264"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2B2B2B" stop-opacity="0" />
          <stop offset="1" stop-color="#2B2B2B" />
        </linearGradient>
        <clipPath id="clip0_219_1727">
          <rect width="375" height="658" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from '@vue/composition-api'
import { MembersRankDataType } from '@/components/MypageTopPage/MembershipCardPane.vue'
import useMembershipCard from '@/components/MypageTopPage/hook/useMembershipCard'

/**
 * マイページ: 会員証 背景画像パーツ
 */
export default defineComponent({
  name: 'MembershipCardParts',
  components: {},
  props: {
    membersRankData: {
      type: Object as PropType<MembersRankDataType>,
      default: () => ({}),
      require: true,
    },
    isFreePlan: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const { getMembersRankColor } = useMembershipCard()
    const membersColor = computed(() =>
      getMembersRankColor(props.membersRankData.currentRank, props.isFreePlan),
    )

    return {
      membersColor,
    }
  },
  methods: {},
})
</script>

<style lang="scss" scoped>
.membership-card-bg-parts {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;

  &__image {
    display: none;
    position: absolute;
    top: 0;
    right: 50%;
    width: 100%;
    min-width: 375px;
    max-width: 800px;
    transform: translate(50%, 0);
    overflow: visible;

    @media screen and (min-width: $responsiveTabletWidth) {
      &--pc {
        display: initial;
      }
    }

    @media screen and (max-width: $responsiveTabletWidth - 1px) {
      &--sp {
        display: initial;
      }
    }
  }
}
</style>
